<template>
    <div>

        <!-- Dialog de confirmação -->
        <v-dialog v-model="dialogConfirm" max-width="400">
            <v-card>
                <v-card-title class="text-h6">Confirmação</v-card-title>
                <v-card-text>
                    {{ confirmMessage }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dialogConfirm = false">Cancelar</v-btn>
                    <v-btn text color="primary" @click="executarConfirmacao()">Confirmar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Dialog Campanha-->
        <v-dialog v-model="dialogCampanha" max-width="1024" scrollable>
            <v-card>
                <v-card-title>
                    <h3>Plano de Fundo SIC - Campanha</h3>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogImgCampanhaClose()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-divider></v-divider>
                    <v-row class="mt-2">
                        <v-col cols="12">
                            <v-text-field v-model="ipfundo.ipf_descricao" type="text" label="Descrição da Campanha"
                                required outlined counter="100" maxlength="100" />
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <div class="text-h6">Tipo da Campanha</div>
                    <v-row>
                        <v-col cols="12" class="pb-0">
                            <v-radio-group v-model="ipfundo.ipf_tipo_camp" row hide-details class="ma-0 pa-0"
                                v-on:change="alterarTipoCampanha">
                                <v-radio label="1-Todos Clientes" :value="1" />
                                <v-radio label="2-Por UF" :value="2" />
                                <v-radio label="3-Por UF e Cidade" :value="3" />
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-select v-model="ipfundo.ipf_uf" :items="ufs" label="UF" prepend-icon="mdi-map" outlined
                                dense :disabled="desabilitarUf" v-on:change="carregarCidade" :loading="loadingUf" />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-select v-model="ipfundo.ipf_cidade" :items="cidades" label="Cidade"
                                prepend-icon="mdi-city" outlined dense :disabled="desabilitarCidade || loadingCidade"
                                :loading="loadingCidade" />
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <div class="text-h6 mb-5 ">Período da Campanha</div>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="ipfundo.ipf_dtinicial" label="Data Inicial" type="date"
                                prepend-icon="mdi-calendar-start" outlined dense />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="ipfundo.ipf_dtfinal" label="Data Final" type="date"
                                prepend-icon="mdi-calendar-end" outlined dense />
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <div class="text-h6 mt-1 mb-2">Imagens da Campanha</div>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-file-input v-model="ipfundo100" label="Imagem da Campanha Padrão 100%" required
                                prepend-icon="image" accept="image/*" dense outlined>
                                <template v-slot:selection>
                                    {{ ipfundo100.name }}
                                </template>
                            </v-file-input>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-file-input v-model="ipfundo50" label="Imagem da Campanha Padrão 50%" required
                                prepend-icon="image" accept="image/*" dense outlined>
                                <template v-slot:selection>
                                    {{ ipfundo50.name }}
                                </template>
                            </v-file-input>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <div class="text-h6 mt-1">Chave Clientes Especifico</div>
                    <v-row class="mt-0 pt-0">
                        <v-col cols="12">
                            <v-text-field v-model="ipfundo.ipf_id_clientes" type="text" label="Chave clientes (ID)"
                                :disabled="this.ipfundo.ipf_tipo_camp != 1" outlined />
                        </v-col>
                    </v-row>
                    <v-row class="mt-0 pt-0">
                        <v-col cols="12" class="py-0">
                            <v-checkbox v-model="ipfundo.ipf_camp_inativo" v-if="ipfundo.id" color="green" hide-details
                                class="ma-0 pa-0">
                                <template v-slot:label>
                                    Inativar campanha?
                                </template>
                            </v-checkbox>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="red" v-if="ipfundo.id" dark
                        @click="abrirConfirmacao('Deseja realmente excluir a campanha?', () => excluirCampanha())"
                        :loading="loadingExcluirCampanha">
                        Excluir
                    </v-btn>
                    <v-btn color="blue" dark @click="salvarCampanha()" :loading="loadingSalvarCampanha">
                        Salvar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Dialog Img Padrao-->
        <v-dialog v-model="dialogImgPadrao" max-width="500" scrollable>
            <v-card>
                <v-card-title>
                    Imagens Padrão
                    <v-spacer></v-spacer>
                    <v-btn icon @click=" dialogImgPadraoClose()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-row align="center" no-gutters>
                                <v-col>
                                    <v-file-input v-model="ipfundo100" label="Imagem Padrão 100%" required
                                        prepend-icon="image" accept="image/*">
                                        <template v-slot:selection>
                                            {{ ipfundo100?.name }}
                                        </template>
                                    </v-file-input>
                                </v-col>
                                <v-col cols="auto" class="ml-2">
                                    <v-btn v-if="ipfundo.id" icon small color="primary"
                                        @click.stop="abrirLink(ipfundo.ipf_url_100)">
                                        <v-icon title="Visualizar">
                                            mdi-cloud-download
                                        </v-icon>
                                    </v-btn>
                                </v-col>

                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-row align="center" no-gutters>
                                <v-col>
                                    <v-file-input v-model="ipfundo50" label="Imagem Padrão 50%" required
                                        prepend-icon="image" accept="image/*">
                                        <template v-slot:selection>
                                            {{ ipfundo50.name }}
                                        </template>
                                    </v-file-input>
                                </v-col>
                                <v-col cols="auto" class="ml-2">
                                    <v-btn v-if="ipfundo.id" icon small color="primary"
                                        @click.stop="abrirLink(ipfundo.ipf_url_50)">
                                        <v-icon title="Visualizar">
                                            mdi-cloud-download
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-progress-linear v-if="loadingCarregarPadrao" indeterminate color="primary"></v-progress-linear>
                    <v-spacer></v-spacer>
                    <v-btn color="red" v-if="ipfundo.id" dark
                        @click="abrirConfirmacao('Deseja realmente excluir?', () => excluirIpfundoPadrao())"
                        :loading="loadingExcluirPadrao">
                        Excluir
                    </v-btn>
                    <v-btn color="primary" v-show="!loadingCarregarPadrao" @click="salvarImgPadrao"
                        :disabled="(!ipfundo50 && !ipfundo50) || (ipfundo50.size <= 1 && ipfundo100.size <= 1)"
                        :loading="loadingSalvarPadrao">
                        Salvar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Demais-->
        <v-card>
            <v-card-title>
                <v-btn class="white--text" color="primary" elevation="2" @click="dialogImgPadraoShow">
                    Imagem Padrão
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn class="white--text" color="primary" elevation="2" @click="dialogCampanhaShow">
                    <v-icon left> mdi-plus </v-icon>
                    Nova Campanha
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-data-table :headers="headers" :items="ipfundos" class="elevation-1" :loading="loading"
                    @click:row="loadingIpfundo" pagi>
                    <template v-slot:[`item.ipf_camp_inativo`]="{ item }">
                        <v-icon color="green" v-if="item.ipf_camp_inativo == false"
                            title="Sim">check_circle_outline</v-icon>
                        <v-icon color="red" v-if="item.ipf_camp_inativo == true" title="Não">mdi-cancel</v-icon>
                    </template>

                    <template v-slot:[`item.ipf_dtinicial`]="{ item }">
                        {{ convertDate(item.ipf_dtinicial) }}
                    </template>

                    <template v-slot:[`item.ipf_dtfinal`]="{ item }">
                        {{ convertDate(item.ipf_dtfinal) }}
                    </template>

                    <template v-slot:[`item.ipf_url_100`]="{ item }">
                        <v-btn icon small color="primary" @click.stop="abrirLink(item.ipf_url_100)">
                            <v-icon title="Visualizar">mdi-cloud-download </v-icon>
                        </v-btn>
                    </template>

                    <template v-slot:[`item.ipf_url_50`]="{ item }">
                        <v-btn icon small color="primary" @click.stop="abrirLink(item.ipf_url_50)">
                            <v-icon title="Visualizar">mdi-cloud-download</v-icon>
                        </v-btn>
                    </template>

                    <template v-slot:[`item.ipf_tipo_camp`]="{ item }">

                        <div class="d-flex align-center">

                            <!-- Geral -->
                            <v-tooltip bottom v-if="item.ipf_tipo_camp == 1">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="primary" v-bind="attrs" v-on="on">
                                        mdi-earth
                                    </v-icon>
                                </template>

                                <span>Campanha Geral</span>
                            </v-tooltip>

                            <span class="ml-2" v-if="item.ipf_tipo_camp == 1">
                                Geral
                            </span>

                            <!-- UF -->
                            <v-tooltip bottom v-else-if="item.ipf_tipo_camp == 2">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="orange" v-bind="attrs" v-on="on">
                                        mdi-map
                                    </v-icon>
                                </template>

                                <span>Campanha por UF</span>
                            </v-tooltip>

                            <span class="ml-2" v-if="item.ipf_tipo_camp == 2">
                                UF
                            </span>

                            <!-- Cidade -->
                            <v-tooltip bottom v-else-if="item.ipf_tipo_camp == 3">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="green" v-bind="attrs" v-on="on">
                                        mdi-city
                                    </v-icon>
                                </template>

                                <span>Campanha por Cidade</span>
                            </v-tooltip>

                            <span class="ml-2" v-if="item.ipf_tipo_camp == 3">
                                Cidade
                            </span>

                        </div>

                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            ipfundos: [],
            headers: [
                { text: 'Descrição', value: 'ipf_descricao' },
                { text: 'Tipo da Campanha', value: 'ipf_tipo_camp' },
                { text: 'UF', value: 'ipf_uf' },
                { text: 'Cidade', value: 'ipf_cidade' },
                { text: 'Data Inicial', value: 'ipf_dtinicial' },
                { text: 'Data Final', value: 'ipf_dtfinal' },
                { text: 'Imagem 100%', value: 'ipf_url_100' },
                { text: 'Imagem 50%', value: 'ipf_url_50' },
                { text: 'Ativo', value: 'ipf_camp_inativo' },
            ],
            cidades: [],
            ufs: [],
            desabilitarUf: true,
            desabilitarCidade: true,
            ipfundo: {
                ipf_uf: null,
                ipf_cidade: null
            },
            ipfundo100: null,
            ipfundo50: null,
            loadingCarregarPadrao: false,
            loadingSalvarPadrao: false,
            loadingExcluirCampanha: false,
            loadingExcluirPadrao: false,
            loadingSalvarCampanha: false,
            loadingCidade: false,
            loadingUf: false,
            dialogCampanha: false,
            dialogImgPadrao: false,
            dialogLoading: false,
            loading: false,
            dialogConfirm: false,
            confirmMessage: '',
            confirmAction: null,
        }
    },
    computed: {
        ...mapGetters(['userMaster', 'userPlanoFundoSic']),
    },
    methods: {
        abrirConfirmacao(mensagem, acao) {
            this.confirmMessage = mensagem;
            this.confirmAction = acao;
            this.dialogConfirm = true;
        },
        executarConfirmacao() {
            if (this.confirmAction) this.confirmAction(); // executa a função passada
            this.dialogConfirm = false;                     // fecha o diálogo
        },
        /*
         * Validadores
         */
        validarImagem(file) {
            if (!file) {
                this.$store.dispatch('showError', 'Selecione uma imagem')
                return false
            }

            if (this.ipfundo.id)
                return true;

            if (!file.type.startsWith('image/')) {
                this.$store.dispatch('showError', 'O arquivo selecionado não é uma imagem')
                return false
            }

            const maxSize = 5 * 1024 * 1024

            if (file.size > maxSize) {
                this.$store.dispatch('showError', 'Imagem deve ter no máximo 5MB')
                return false
            }
            return true;
        },
        validaDescricao(text) {

            if (!text || text.trim() === "") {
                this.$store.dispatch('showError', "Informe uma descrição")
                return false;
            }

            return true;
        },
        validaDataInicial(value) {
            if (!value) {
                this.$store.dispatch('showError', 'Informe a data inicial')
                return false
            }

            const data = new Date(value)

            if (isNaN(data.getTime())) {
                this.$store.dispatch('showError', 'Data inicial inválida')
                return false
            }

            if (this.ipfundo.ipf_dtfinal && value > this.ipfundo.ipf_dtfinal) {
                this.$store.dispatch('showError', 'A data inicial não pode ser maior que a final')
                return false
            }

            return true
        },
        validaDatafinal(value) {
            if (!value) {
                this.$store.dispatch('showError', 'Informe a data final')
                return false
            }

            const data = new Date(value)

            if (isNaN(data.getTime())) {
                this.$store.dispatch('showError', 'Data final inválida')
                return false
            }

            if (this.ipfundo.ipf_dtinicial && value < this.ipfundo.ipf_dtinicial) {
                this.$store.dispatch('showError', 'A data final não pode ser menor que a inicial')
                return false
            }

            return true
        },
        validaCidade(value) {

            if (this.ipfundo.ipf_tipo_camp === 3) {
                if (!value) {
                    this.$store.dispatch('showError', 'Informe a cidade')
                    return false
                }

                if (!this.cidades.includes(value)) {
                    this.$store.dispatch('showError', 'Informe a cidade')
                    return false;
                }
            }
            return true
        },
        validaUf(value) {
            if (
                (this.ipfundo.ipf_tipo_camp === 2 ||
                    this.ipfundo.ipf_tipo_camp === 3)
                && !value
            ) {
                this.$store.dispatch('showError', 'Informe a UF')
                return false
            }

            return true
        },
        ValidaSalvarCampanha() {

            if (!this.validaDescricao(this.ipfundo.ipf_descricao)) return false
            if (!this.validaUf(this.ipfundo.ipf_uf)) return false
            if (!this.validaCidade(this.ipfundo.ipf_cidade)) return false
            if (!this.validaDataInicial(this.ipfundo.ipf_dtinicial)) return false
            if (!this.validaDatafinal(this.ipfundo.ipf_dtfinal)) return false
            if (!this.validarImagem(this.ipfundo100)) return false
            if (!this.validarImagem(this.ipfundo50)) return false
            return true;
        },

        /**
         * Salvar
         */
        async salvarImgPadrao() {
            try {
                this.loadingSalvarPadrao = true;
                if (this.ipfundo.id)
                    await this.atualizaIpfundoPadrao();
                else
                    await this.novoIpfundoPadrao()

            } catch (error) {
                this.$store.dispatch('showError', error)
            } finally {
                this.loadingSalvarPadrao = false;
            }
        },
        async novoIpfundoPadrao() {
            try {
                if (!this.ipfundo100 && !this.ipfundo.ipf_nome_100) {
                    this.$store.dispatch('showError', 'Informe a imagem 100%')
                    return
                }

                if (!this.ipfundo50 && !this.ipfundo.ipf_nome_50) {
                    this.$store.dispatch('showError', 'Informe a imagem 50%')
                    return
                }

                const formData = new FormData()
                formData.append('imagem100', this.ipfundo100)
                formData.append('imagem50', this.ipfundo50)
                formData.append('ipf_camp_inativo', true)
                formData.append('ipf_tipo', '0')

                await this.axios.post(`/config/sic/ipfundo`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                this.$store.dispatch('showSuccess', 'Imagem salva com sucesso!');
                this.dialogImgPadraoClose();
            } catch (error) {
                this.$store.dispatch('showError', error)
            }
        },
        async atualizaIpfundoPadrao() {
            try {
                if (!this.ipfundo100 && !this.ipfundo50) {
                    this.$store.dispatch('showError', 'Informe as imagens padrão.')
                    return
                }

                const formData = new FormData()
                formData.append('imagem100', this.ipfundo100)
                formData.append('imagem50', this.ipfundo50)
                formData.append('ipf_camp_inativo', false)
                formData.append('ipf_tipo', '0')
                formData.append('id', this.ipfundo.id)

                await this.axios.put(`/config/sic/ipfundo/${this.ipfundo.id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                this.$store.dispatch('showSuccess', 'Imagem atualizada com sucesso!');
                this.dialogImgPadraoClose();
            } catch (error) {
                this.$store.dispatch('showError', error)
            }
        },
        async excluirIpfundoPadrao() {
            try {
                this.loadingExcluirPadrao = true;
                await this.axios.delete(`/config/sic/ipfundo/${this.ipfundo.id}`)
                this.loadingExcluirPadrao = false;
                this.dialogImgPadraoClose();
                this.$store.dispatch('showSuccess', 'Camapanha excluida com sucesso!');
            } catch (error) {
                this.$store.dispatch('showError', error)
            }

        },
        async excluirCampanha() {
            try {
                this.loadingExcluirCampanha = true;
                await this.axios.delete(`/config/sic/ipfundo/${this.ipfundo.id}`)
                this.loadingExcluirCampanha = false;
                this.dialogImgCampanhaClose();
                this.$store.dispatch('showSuccess', 'Camapanha excluida com sucesso!');
            } catch (error) {
                this.$store.dispatch('showError', error)
            }
        },
        async salvarCampanha() {
            if (this.ValidaSalvarCampanha()) {
                this.loadingSalvarCampanha = true;
                if (this.ipfundo.id)
                    await this.atualizarCampanha()
                else
                    await this.novaCampanha()

                this.dialogImgCampanhaClose();
                this.loadingSalvarCampanha = false;
            }
        },
        async atualizarCampanha() {
            try {
                const formData = new FormData()
                formData.append('imagem100', this.ipfundo100)
                formData.append('imagem50', this.ipfundo50)
                formData.append('id', this.ipfundo.id)
                formData.append('ipf_camp_inativo', this.ipfundo.ipf_camp_inativo)
                formData.append('ipf_tipo', '1')
                formData.append('ipf_descricao', this.ipfundo.ipf_descricao)
                formData.append('ipf_tipo_camp', this.ipfundo.ipf_tipo_camp)
                formData.append('ipf_uf', this.ipfundo.ipf_uf)
                formData.append('ipf_cidade', this.ipfundo.ipf_cidade)
                formData.append('ipf_dtinicial', this.ipfundo.ipf_dtinicial)
                formData.append('ipf_dtfinal', this.ipfundo.ipf_dtfinal)
                formData.append('ipf_id_clientes', this.ipfundo.ipf_id_clientes)

                await this.axios.put(`/config/sic/ipfundo/${this.ipfundo.id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                this.$store.dispatch('showSuccess', 'Campanha atualizada com sucesso!');
                this.dialogImgCampanhaClose();

            } catch (error) {
                this.$store.dispatch('showError', error)
            }
        },
        async novaCampanha() {
            try {
                const formData = new FormData()
                formData.append('imagem100', this.ipfundo100)
                formData.append('imagem50', this.ipfundo50)
                formData.append('ipf_camp_inativo', false)
                formData.append('ipf_tipo', '1')
                formData.append('ipf_descricao', this.ipfundo.ipf_descricao)
                formData.append('ipf_tipo_camp', this.ipfundo.ipf_tipo_camp)
                formData.append('ipf_uf', this.ipfundo.ipf_uf)
                formData.append('ipf_cidade', this.ipfundo.ipf_cidade)
                formData.append('ipf_dtinicial', this.ipfundo.ipf_dtinicial)
                formData.append('ipf_dtfinal', this.ipfundo.ipf_dtfinal)
                formData.append('ipf_id_clientes', this.ipfundo.ipf_id_clientes)

                await this.axios.post(`/config/sic/ipfundo`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                this.$store.dispatch('showSuccess', 'Campanha salva com sucesso!');
                this.dialogImgCampanhaClose();

            } catch (error) {
                this.$store.dispatch('showError', error)
            }
        },
        async loadingIpfundo(ipfundo) {
            try {
                const response = await this.axios.get(`/config/sic/ipfundo/${ipfundo.id}`);

                this.ipfundo = response.data.ipfundo || {}

                if (this.ipfundo.ipf_nome_100)
                    this.ipfundo100 = new File([0], this.ipfundo.ipf_nome_100)

                if (this.ipfundo.ipf_nome_50)
                    this.ipfundo50 = new File([0], this.ipfundo.ipf_nome_50)

                if (this.ipfundo.ipf_dtinicial)
                    this.ipfundo.ipf_dtinicial = this.ipfundo.ipf_dtinicial.split('T')[0]

                if (this.ipfundo.ipf_dtfinal)
                    this.ipfundo.ipf_dtfinal = this.ipfundo.ipf_dtfinal.split('T')[0]

                await this.dialogCampanhaShow();

            } catch (error) {
                this.$store.dispatch('showError', error)
            }
        },
        async loadingIpfundoAll() {
            try {

                this.loading = true;
                const response = await this.axios.get('/config/sic/ipfundo', {
                    params: {
                        tipo: 1
                    }
                })

                this.ipfundos = response.data.ipfundo
            } catch (error) {
                this.$store.dispatch('showError', error)
            }
            finally {
                this.loading = false
            }
        },
        //Dialogs
        async dialogImgPadraoShow() {
            try {
                this.loadingCarregarPadrao = true;
                this.dialogImgPadrao = true
                this.ipfundo.ipf_tipo = 0
                await this.carregaIpfundoPadrao();
            } catch (error) {
                this.$store.dispatch('showError', error)
            }
            finally {
                this.loadingCarregarPadrao = false;
            }
        },
        async dialogCampanhaShow() {
            try {
                this.dialogCampanha = true;
                await this.carregaUfs();
                if (!this.ipfundo.id) {
                    this.ipfundo.ipf_tipo_camp = 1;
                    this.desabilitarUf = true;
                }
                else {
                    if (this.ipfundo.ipf_uf && this.ipfundo.ipf_tipo_camp == 3) {
                        await this.carregarCidade()
                    }
                }

                await this.alterarTipoCampanha(this.ipfundo.ipf_tipo_camp)

            } catch (error) {
                this.$store.dispatch('showError', error)
            }
        },
        dialogImgPadraoClose() {
            this.ipfundo = {};
            this.ipfundo100 = null;
            this.ipfundo50 = null;
            this.dialogImgPadrao = false;
        },
        dialogImgCampanhaClose() {
            this.ipfundo = {};
            this.ipfundo100 = null;
            this.ipfundo50 = null;
            this.dialogCampanha = false;
            this.loadingIpfundoAll();
        },
        //Carregar
        async carregaIpfundoPadrao() {
            try {
                const response = await this.axios.get('/config/sic/ipfundo', {
                    params: {
                        tipo: 0
                    }
                })

                this.ipfundo = response.data.ipfundo || {}

                if (this.ipfundo.ipf_nome_100)
                    this.ipfundo100 = new File([0], this.ipfundo.ipf_nome_100)

                if (this.ipfundo.ipf_nome_50)
                    this.ipfundo50 = new File([0], this.ipfundo.ipf_nome_50)

            } catch (error) {
                this.$store.dispatch('showError', error)
            }
        },
        async carregaUfs() {
            try {
                this.loadingUf = true;
                const response = await this.axios.get('/config/sic/ufs');
                this.ufs = response.data
            } catch (error) {
                this.$store.dispatch('showError', error)
            }
            finally {
                this.loadingUf = false;
            }
        },
        async carregarCidade() {
            try {

                this.cidades = []
                this.loadingCidade = true

                if (!this.ipfundo.ipf_uf)
                    return

                const response = await this.axios.get('/config/sic/cidades', {
                    params: {
                        uf: this.ipfundo.ipf_uf
                    }
                })
                this.cidades = response.data
            } catch (error) {
                this.$store.dispatch('showError', error)
            }
            finally {
                this.loadingCidade = false;
            }
        },
        async alterarTipoCampanha(value) {
            const tipo = Number(value);
            this.ipfundo.ipf_tipo_camp = tipo;
            this.desabilitarUf = tipo === 1;
            this.desabilitarCidade = tipo !== 3;
            if (tipo == 1) {
                this.ipfundo.ipf_uf = null;
                this.ipfundo.ipf_cidade = null;
                this.cidades = []
            }

            if (tipo == 2) {
                this.ipfundo.ipf_cidade = null;
            }

            if (tipo != 1) {
                this.ipfundo.ipf_id_clientes = null;
            }
        },
        abrirLink(url) {
            if (!url) return

            window.open(url, '_blank')
        }
    },
    mounted() {
        this.loadingIpfundoAll()
    },
    watch: {

    }
}
</script>